import { render, staticRenderFns } from "./setting2.vue?vue&type=template&id=60465656&"
import script from "./setting2.vue?vue&type=script&lang=js&"
export * from "./setting2.vue?vue&type=script&lang=js&"
import style0 from "./setting2.vue?vue&type=style&index=0&id=60465656&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports